import { z } from 'zod'

import { LightFlowSchema } from './lightFlow'

export const WelcomeMessageSchema = z.object({
  enabled: z.boolean(),
  content_holder: z.string(),
  channel: z.string(),
  flow: LightFlowSchema.nullable().optional(),
})
